import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { ColorService } from '../../shared/services/color.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from "@angular/forms";
import { OPCConstant } from "../../opc-app/opc.const";
import { NotificationService } from "../../shared/services/notification.service";
import { Message, ConfirmationService } from 'primeng/api';
@Component({
  selector: 'app-color-item',
  templateUrl: './color-item.component.html',
  styleUrls: ['./color-item.component.css']

})
export class ColorItemComponent implements OnInit {
  @Input() allColors: any;
  @Input() colorItems: any;
  @Output() isgetColors: EventEmitter<any> = new EventEmitter();
  notifications: Message[] = [];
  backgroundColorCode: string;
  viewColor: string;
  loading = false;
  popupHeader: string;
  editColorCode: string;
  confirmDeleteShow: boolean = false;
  warningDeleteShow: boolean = false;
  deleteColorId: any;
  coloSlashRequired: boolean = false;
  coloSlashNotRequired: boolean = false;
  validColor: boolean =false;

  constructor(private colorService: ColorService, private spinner: NgxSpinnerService, private fb: FormBuilder, private notifyService: NotificationService, private confirmationService: ConfirmationService,
  ) {

  }
  addColorForm: any;

  public show: boolean = false;
  ngOnInit(): void {
    this.colorService.canMoveFromColorComponent = true;
    this.loading = true;
    this.spinner.show();
    window.addEventListener('popstate', (event) => {
      if (this.show) {
        this.colorService.canMoveFromColorComponent = this.addColorForm.dirty ? false : true;
      }
    })
  }

  addFormValues(id) {
    this.coloSlashNotRequired = false;
    try {
      if (id == 0) {
        this.viewColor = '-webkit-linear-gradient(-53deg, white 49%,white 51%)';
        this.addColorForm = this.fb.group({
          ColorCodeID: [0],
          Code: ["", [Validators.required]],
          ColorCodeDesc: ["", [Validators.required]],
          CSSColorCode1: ["", [Validators.required]],
          CSSColorCode2: [""],
        })
        this.coloSlashRequired = false;
      }
      else {

        this.show = true;
        var getColorDetails = this.allColors.find(c => c.colorCodeID === id);
        if (getColorDetails.code.includes('/') || getColorDetails.colorCodeDesc.includes("/")) {
          var colorCodeList = getColorDetails.code.includes('/') ? getColorDetails.code.split("/") : getColorDetails.colorCodeDesc.split("/");
          var colorCode1 = this.allColors.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null) ? this.allColors.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null).cssColorCode:'null';
          var colorCode2 = this.allColors.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null) ? this.allColors.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null).cssColorCode : 'null';
          var TempcolorCode1 = colorCode1 == 'null' ? 'white' : colorCode1;
          var TempcolorCode2 = colorCode2 == 'null' ? 'white' : colorCode2;
          this.backgroundColorCode = '-webkit-linear-gradient(-53deg,' + TempcolorCode1 + ' 49%, ' + TempcolorCode2 + ' 51%)';

        }
        else {
          var colorCode1 = getColorDetails.cssColorCode;
          var colorCode2: any = "";
          this.backgroundColorCode = '-webkit-linear-gradient(-53deg,' + colorCode1 + ' 49%, ' + colorCode1 + ' 51%)';

        }
        this.popupHeader = "Edit Color";
        this.addColorForm = this.fb.group({
          ColorCodeID: [getColorDetails.colorCodeID],
          Code: [getColorDetails.code, [Validators.required]],
          ColorCodeDesc: [getColorDetails.colorCodeDesc, [Validators.required]],
          CSSColorCode1: [colorCode1 != 'null' ? colorCode1:"", [Validators.required]],
          CSSColorCode2: [colorCode2 != 'null' ? colorCode2 : ""],
        })
        this.viewColor = this.backgroundColorCode;
        this.editColorCode = getColorDetails.code;
        this.coloSlashRequired = false;
      }
    }
    catch (error) {
    }
  }

  openPopUp() {
    this.show = true;
    this.popupHeader = "Add Color"
    this.addFormValues(0);
  }
  closePopUp() {
    this.show = false;
    this.warningDeleteShow = false;
    this.confirmDeleteShow = false;
    this.colorService.canMoveFromColorComponent = true;
  }

  saveColorForm() {
    this.colorSlashNotRequired();
    if (this.addColorForm.valid && this.colorSlashRequired && !this.coloSlashNotRequired) {
      if (this.addColorForm.value.ColorCodeID == 0) {
        this.colorService.addColorForm(this.addColorForm.value).subscribe((res) => {
          if (res) {
            this.notifications = this.notifyService.growlNotification('succ', OPCConstant.ADDED_SUCCESS);
            this.isgetColors.emit(res);
          }
          else {
            this.notifications = this.notifyService.growlNotification('fail', OPCConstant.ADDED_FAILURE);
          }
        });
      }
      else {
        if (this.addColorForm.dirty) {
          this.colorService.updateColorForm(this.addColorForm.value).subscribe((res) => {
            if (res) {
              this.notifications = this.notifyService.growlNotification('succ', OPCConstant.UPDATE_SUCCESS);
              this.isgetColors.emit(res);
            }
            else {
              this.notifications = this.notifyService.growlNotification('fail', OPCConstant.UPDATE_FAILURE);
            }
          });
        }
      }
      this.show = false;
      this.colorService.canMoveFromColorComponent = true;
    }
  }
  onColorFieldChange() {
    this.coloSlashNotRequired = false;
    var colorCode1 = this.addColorForm.value.CSSColorCode1 ? this.addColorForm.value.CSSColorCode1 : null;
    var colorCode2 = this.addColorForm.value.CSSColorCode2 ? this.addColorForm.value.CSSColorCode2 : null;
    if (colorCode1 != null && colorCode2 != null) {
      this.backgroundColorCode = '-webkit-linear-gradient(-53deg,' + colorCode1 + ' 49%, ' + colorCode2 + ' 51%)';
    }
    else if (colorCode1 == null) {
      this.backgroundColorCode = '-webkit-linear-gradient(-53deg,' + colorCode2 + ' 49%, ' + colorCode2 + ' 51%)';
    }
    else if (colorCode2 == null) {
      this.backgroundColorCode = '-webkit-linear-gradient(-53deg,' + colorCode1 + ' 49%, ' + colorCode1 + ' 51%)';
    }
    else {
      this.backgroundColorCode = '-webkit-linear-gradient(-53deg, white 50%, white 50%)';
    }
    this.viewColor = this.backgroundColorCode;
    this.colorSlashRequired();
  }

  onColorChange(id, desc) {
    var codeId = id;
    var colorCodeDesc = desc;
    this.backgroundColorCode = '-webkit-linear-gradient(-61deg, white 50%, white 50%)';
    if ((codeId.indexOf('/')>-1||colorCodeDesc.indexOf('/') > -1) && colorCodeDesc !== 'none') {
      var colorCodeList = codeId.includes('/') ? codeId.split("/") : colorCodeDesc.split("/");
      try {
        var colorCode1 = this.allColors.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null) ? this.allColors.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null).cssColorCode : 'white';
        var colorCode2 = this.allColors.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null) ? this.allColors.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null).cssColorCode : 'white';
        this.backgroundColorCode = '-webkit-linear-gradient(-61deg,' + colorCode1 + ' 49%, ' + colorCode2 + ' 51%)';
        return this.backgroundColorCode;
      }
      catch (error) {

      }
    }
    else {
      var colors: string;
      if (colorCodeDesc == 'none') {
        colors = '#FFFFFF'
      } else {
        colors = this.allColors.find(c => c.code == codeId).cssColorCode;
      }
      this.backgroundColorCode = '-webkit-linear-gradient(-61deg,' + colors + ' 50%, ' + colors + ' 50%)';
      return this.backgroundColorCode;

    }
  }
  colorCodeExists(type) {
    this.colorSlashRequired();
    this.validColorCode();
    this.coloSlashNotRequired = false;
    if (type === "new") {
      var code = this.addColorForm.value.Code;
      var colorCodeExists = this.allColors.find(c => c.code === code);
      if (colorCodeExists != null) {
        this.addColorForm.controls.Code.setErrors({
          verifyFailure: true
        });
      }
    }
    else {
      if (this.addColorForm.value.Code != this.editColorCode) {
        var code = this.addColorForm.value.Code;
        var colorCodeExists = this.allColors.find(c => c.code === code);
        if (colorCodeExists != null) {
          this.addColorForm.controls.Code.setErrors({
            verifyFailure: true
          });
        }
      }
    }
  }
  ConfirmDelete(i) {
    this.confirmDeleteShow = false;
    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      key: i,
      message: OPCConstant.CONFIRM_MESSAGE,
      accept: () => {
        this.colorService.deleteColor(this.deleteColorId).subscribe((res) => {
          if (res) {
            this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_SUCCESS);
            this.isgetColors.emit(res);
          }
          else {
            this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_FAILURE);
          }
        },
          error => {
            this.notifications = this.notifyService.growlNotification('fail', OPCConstant.PC_DELETE_FAILURE);
          }
        );
      }
    });
  }
  deleteColor(colorId, colorCode, i) {
    this.deleteColorId = colorId;
    var ColorCode = {
      ColorCodeID: colorId,
      Code: colorCode
    }
    var allparts: any;
    this.colorService.existingRecord(ColorCode).subscribe((res) => {
      if (!res) {
        this.ConfirmDelete(i);
      }
      else {
        this.warningDeleteShow = true;
      }
    })
  }
  colorSlashRequired() {
    this.validColorCode();
    if (this.addColorForm.value.CSSColorCode2.trim() != "") {
      if (!this.addColorForm.value.Code.endsWith("/") && !this.addColorForm.value.Code.startsWith("/") && this.addColorForm.value.Code.includes("/") ||
        !this.addColorForm.value.ColorCodeDesc.endsWith("/") && !this.addColorForm.value.ColorCodeDesc.startsWith("/") && this.addColorForm.value.ColorCodeDesc.includes("/") ) {
        this.coloSlashRequired = false;
      }
      else {
        this.coloSlashRequired = true;
      }
    }
    else {
      this.coloSlashRequired = false;
    }
    
  }
  validColorCode() {
    var code = this.addColorForm.value.Code.split("/");
    var desc = this.addColorForm.value.ColorCodeDesc.split("/");
    if (code.length > 2 || desc.length > 2) {
      this.validColor = true;
    }
    else {
      this.validColor = false;
    }
  }
  colorSlashNotRequired() {
    if ((this.addColorForm.value.Code.includes("/") || this.addColorForm.value.Code.includes("/")) && !this.addColorForm.value.CSSColorCode2 || (this.addColorForm.value.ColorCodeDesc.includes("/") || this.addColorForm.value.ColorCodeDesc.includes("/")) && !this.addColorForm.value.CSSColorCode2) {
      this.coloSlashNotRequired = true;
    }
    else {
      this.coloSlashNotRequired = false;
    }
  }
  conformDelete() {
    this.confirmDeleteShow = false;
    this.colorService.deleteColor(this.deleteColorId).subscribe((res) => {
      if (res) {
        this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_SUCCESS);
        this.isgetColors.emit(res);
      }
      else {
        this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_FAILURE);
      }
    })
    this.deleteColorId = 0;

  }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/color/color-item.component.ts